/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import DashboardCompanyBreakdown from 'components/molecules/dashboard_company_breakdown';
import { CompanyCount } from 'hooks/useRepresentantDashboard';
import { ImminenceTypes } from 'store/modules/get_dados_imminence_store/types';
import { useDispatch } from 'react-redux';
import createTrack from 'services/actions/tracker_actions';
import { Container } from './styles';

interface CardOpportunityProps {
  title: string;
  background: string;
  value: number;
  url: string;
  shortcut?: string;
  breakdown?: CompanyCount[];
  error?: boolean;
}

const CardOpportunity: React.FC<CardOpportunityProps> = ({
  title,
  background,
  value,
  url,
  shortcut,
  breakdown,
  error,
}) => {
  const dispatch = useDispatch();
  const [showBreakdown, setShowBreakdown] = useState(false);
  const breakdownItems = (breakdown || []).filter((item) => item.value !== 0);
  const breakdownId = `breakdown-${shortcut || url}-${title}`.replace(/[^\w-]/g, '');
  const breakdownTrigger =
    !error && breakdownItems.length > 0
      ? {
          className: 'breakdown-trigger',
          tabIndex: 0,
          'aria-describedby': breakdownId,
          onMouseEnter: () => setShowBreakdown(true),
          onMouseLeave: () => setShowBreakdown(false),
          onFocus: () => setShowBreakdown(true),
          onBlur: () => setShowBreakdown(false),
        }
      : {};

  const handleClick = (shortcut: string | undefined, url: string) => {
    createTrack(`Dashboard - Clicou em visualizar ${title}`);
    if (shortcut) {
      dispatch({ type: ImminenceTypes.SHOW_PAGE, page: shortcut });
    }
    window.location.href = url;
  };

  return (
    <Container background={background}>
      <div className="p-4" style={{ borderRadius: '8px' }}>
        <p>{title}</p>
        <h2 className="font-weight-bold">
          <span {...breakdownTrigger}>{error ? '--' : value}</span>
        </h2>
        <button
          type="button"
          className="btn btn-link p-0 m-0"
          onClick={() => handleClick(shortcut, url)}
        >
          Visualizar
        </button>
        {showBreakdown && (
          <div className="breakdown-popover">
            <DashboardCompanyBreakdown
              id={breakdownId}
              title={title}
              total={value || 0}
              items={breakdownItems}
            />
          </div>
        )}
      </div>
    </Container>
  );
};

export default CardOpportunity;
